<template>
    <div class="container-xxl padding-container-matrix">
        <div class="row justify-content-center">
            <div class="col-matrix">
                <div
                    v-for="(section, index) in sectionBlock"
                    :key="'sectionAlt-' + index"
                    class="row row-alternate-section"
                >
                    <div class="col-img col-12 col-lg-6">
                        <img :src="section.img.url" :alt="section.img.title" />
                        <h5 v-if="index < 9" class="index-tag">{{'0'}}{{index + 1}}</h5>
                        <h5 v-else class="index-tag">{{index + 1}}</h5>
                    </div>

                    <div class="col-text col-12 col-lg-6">
                        <div class="col-text-content">
                            <h5 v-if="index < 9" class="index-tag-mob">{{'0'}}{{index + 1}}</h5>
                            <h5 v-else class="index-tag-mob">{{index + 1}}</h5>

                            <h4 class="mb-4">{{section.sectionTitle}}</h4>
                            <div class="text-editor" v-html="section.sectionText"></div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
// import AssetLoader from '@/components/helpers/AssetLoader'

export default {
    name: 'alternatelySections',
    components: {
        // AssetLoader
    },
    props: {
        sectionBlock: {
            type: Array,
            required: true,
        },
    },
    computed: {
        pageIsLoaded() {
            return this.contentIsLoaded && this.globalsIsLoaded
        },
        ...mapState(['contentIsLoaded', 'globalsIsLoaded']),
        ...mapGetters(['seo', 'content', 'globals']),
    },
    methods: {
        ...mapActions(['setErrorsReportMsg']),
    },
    // On loaded...
    mounted() {},
}
</script>
